import React from "react";

/**
 * `/iframe-test` — deliberately foreign-styled React page that iframes
 * `/health-check` from a visually unrelated container. Proves the Health
 * Check wizard works end-to-end inside a cross-origin iframe.
 *
 * REPLACES the earlier static `/iframe-test.html` (some static-CDN mirrors
 * swallow .html files via SPA fallback). App.js redirects the legacy URL.
 *
 * The iframe src is pinned to REACT_APP_BACKEND_URL so it also works when
 * this page is served from a static-CDN mirror that doesn't have the app
 * routes.
 */
const BACKEND = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/+$/, "");

export default function IframeTest() {
    return (
        <div
            data-testid="iframe-test-page"
            style={{
                minHeight: "100dvh",
                margin: 0,
                background: "#eef1f5",
                color: "#222",
                fontFamily: '"Courier New", monospace',
                lineHeight: 1.5,
            }}
        >
            <div
                style={{
                    maxWidth: 960,
                    margin: "0 auto",
                    padding: "40px 20px 60px",
                }}
            >
                <span
                    style={{
                        textTransform: "uppercase",
                        letterSpacing: "0.25em",
                        fontSize: 11,
                        color: "#5b7080",
                    }}
                >
                    Iframe embed proof
                </span>
                <h1
                    style={{
                        fontSize: 32,
                        fontWeight: 700,
                        margin: "6px 0 12px",
                        color: "#0f2733",
                    }}
                >
                    This is a foreign page embedding /health-check via iframe.
                </h1>
                <p style={{ fontSize: 15, maxWidth: 640 }}>
                    Everything below the dark bar is the actual MeowMD Health
                    Check tool loaded from a different origin (this page uses
                    Courier + blue-gray; the tool uses cream + teal). Interact
                    with it — you should be able to complete the whole wizard
                    flow inside the frame. Snippet used:{" "}
                    <code
                        style={{
                            background: "#dde3eb",
                            padding: "2px 6px",
                            borderRadius: 3,
                            fontSize: 13,
                        }}
                    >
                        {`<iframe src="${BACKEND}/health-check" style="width:100%; min-height:780px; border:0; border-radius:16px;"></iframe>`}
                    </code>
                </p>

                <div
                    style={{
                        margin: "28px 0",
                        background: "#0f2733",
                        padding: 6,
                        borderRadius: 20,
                        boxShadow: "0 20px 50px rgba(15, 39, 51, 0.15)",
                    }}
                >
                    <iframe
                        data-testid="iframe-hc"
                        src={`${BACKEND}/health-check`}
                        title="MeowMD Free Cat Health Check"
                        loading="lazy"
                        allow="camera; clipboard-read; clipboard-write"
                        style={{
                            display: "block",
                            width: "100%",
                            minHeight: 780,
                            height: "100dvh",
                            maxHeight: 900,
                            border: 0,
                            borderRadius: 16,
                            background: "#F5F0E8",
                        }}
                    />
                </div>

                <footer
                    style={{
                        marginTop: 24,
                        fontSize: 12,
                        color: "#6b7c8a",
                    }}
                >
                    Test page at <code>/iframe-test</code>. Not linked from
                    the main app.
                </footer>
            </div>
        </div>
    );
}
